import { LayoutRectangle } from 'react-native';
import { TooltipProps } from '../base-hover-tooltip/BaseHoverTooltip.types';

export enum STATUS {
  INITIAL = 'INITIAL',
  IDLE = 'IDLE',
  OPENING = 'OPENING',
  CLOSING = 'CLOSING',
}

export type TTooltipState = {
  layout?: LayoutRectangle;
  tooltip?: TooltipProps;
  isVisible: boolean;
};
